import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/lib/mdbvue.css';
import 'vue2-datepicker/index.css';
import '@/assets/scss/style.scss';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import DatePicker from 'vue2-datepicker';
import VueCurrencyFilter from 'vue-currency-filter';
import money from 'v-money';
import Highcharts from 'highcharts';
import VueMq from 'vue-mq';
import axios from 'axios';
import moment from 'moment';
import momentTz from 'moment-timezone';
// import VueSocketIO from 'vue-socket.io';
// import { SOCKET_URL } from '@/utils/api';
import * as VeeValidate from 'vee-validate';
import PhoneNumber from 'awesome-phonenumber';
import interceptorsSetup from '@/middleware/axios-interceptors';
import {
  required, confirmed, numeric, alpha_num,
} from 'vee-validate/dist/rules';
import * as mdbvue from 'mdbvue';
import utils from '@/services/utils';
import Vue2Editor from "vue2-editor";
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

interceptorsSetup();

Object.keys(mdbvue).forEach((key) => {
  Vue.component(key, mdbvue[key]);
});

// Vue.use(new VueSocketIO({
//   debug: true,
//   option: {
//     transport: ['websocket']
//   },
//   connection: SOCKET_URL,
// }));

Vue.use(VeeValidate);

Vue.use(VueAxios, axios);

Vue.use(VueMq, {
  breakpoints: {
    smNav: 1024,
    mdNav: Infinity,
  },
});

Vue.use(money, {
  precision: 2,
  prefix: '฿',
  decimal: '.',
  thousands: ',',
});

momentTz.tz.setDefault('Asia/Hong_Kong');

Vue.prototype.$moment = moment;

Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
  },
});

Vue.use(
  VueCurrencyFilter,[
    {
      thousandsSeparator: ',',
      fractionCount: 2,
      fractionSeparator: '.',
      symbolSpacing: false,
    },
    {
      name: 'currency_no_decimal',
      thousandsSeparator: ',',
      symbolSpacing: false,
    },
  ],
);

Vue.use(Vue2Editor);

const userPersistent = utils.getUserPersistent();
if (userPersistent.token) {
  Vue.axios.defaults.headers.common.Authorization = `Bearer ${utils.getUserPersistent().token}`;
}

Vue.component('DatePicker', DatePicker);

Vue.component('ValidationProvider', VeeValidate.ValidationProvider);

Vue.component('ValidationObserver', VeeValidate.ValidationObserver);

VeeValidate.extend('alpha_num', {
  ...alpha_num,
  message: 'This field may only contain A-Z and 0-9 characters',
});

VeeValidate.extend('required', {
  ...required,
  message: 'This field is required',
});

VeeValidate.extend('numeric', {
  ...numeric,
  message: 'This field allow only numeric',
});

VeeValidate.extend('confirmed', {
  ...confirmed,
  message: 'Password not match',
});

VeeValidate.extend('max', {
  validate(value, { length }) {
    return value.length <= length;
  },
  params: ['length'],
  message: 'This field must have at most {length} characters',
});

VeeValidate.extend('min_value', {
  validate(value, [min]) {
    return value >= min;
  },
  message: 'This field must greater than or equel to 1',
});

VeeValidate.extend('min', {
  validate(value, { length }) {
    return value.length >= length;
  },
  params: ['length'],
  message: 'This field must have at least {length} characters',
});

VeeValidate.extend('phone', {
  message: 'Not a valid phone number',
  validate(value) {
    return new Promise((resolve) => {
      const phone = new PhoneNumber(value, 'TH');
      resolve({ valid: phone.isValid() });
    });
  },
});

VeeValidate.extend('rebate', {
  message: 'Should be 0% to 100%',
  validate(value) {
    return value >= 0 && value <= 100;
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
